import React, { Component } from 'react';
import {connect} from 'react-redux';
import {  metersConversion, round } from '../../helpers/Utils'
import {setSelectedUnit} from "../../actions";

class MetricConverter extends Component {
  constructor(props) {
    super(props);   
}
    state = {conversion_value: '0.092903' }  
    
    toggleSwitch = evt => {
      evt.persist();
      evt.preventDefault();
  
      let arrayUnit = {
        "metric": [
          {
            "type": "SF"
          },
          {
            "type": "SM"
          }
        ]
      };

      let result = arrayUnit.metric.filter(t=>t.type !== this.props.user.unitMetric);
      this.props.setSelectedUnit(result[0].type);

    }
  
    render() {
      const { officerent, cssclassName } = this.props;
      return (
        <div>
          {officerent !=='' ? (
         <div className={cssclassName}> {this.props.user.unitMetric ==='SM' ? (metersConversion(this.props.officerent, this.state.conversion_value)).toFixed(1) : officerent} M
           <sup className="sup cursor-pointer" onClick={this.toggleSwitch}>{this.props.user.unitMetric}</sup>
          </div>
          ) : (<div>--</div>)}
          </div>
      );
    }  
  }

const mapStateToProps = (state) => {
    return {
      user : state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      setSelectedUnit: (selectedUnit) => {
        dispatch(setSelectedUnit(selectedUnit))
      }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MetricConverter);

